import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { SmallTagBase } from '@/components/ui/Tag/SmallTagBase';
const colors = {
    base: 'border-gray-300 text-gray-500',
    inactive: 'border-blue-gray-100 text-blue-gray-100',
    info: 'border-turquoise-blue-100 text-turquoise-blue-100',
    negative: 'border-coral-pink-100 text-coral-pink-100',
    positive: 'border-turquoise-green-100 text-turquoise-green-100',
    secondary: 'border-orange-100 text-orange-100',
};
export const SmallTagOutline = (props) => {
    const { children, className = '', color, isKanjiTopFixed } = props;
    return (_jsx(SmallTagBase, Object.assign({ className: clsx('bg-gray-50', 'border border-solid', colors[color], className), isKanjiTopFixed: isKanjiTopFixed, textColor: 'none' }, { children: children })));
};
